module.exports = __webpack_public_path__ + "img/examen.cd014b56.jpg";